import { Store } from "pullstate";
import { UserClaim } from "types/claimTypes";

const USER_KEY = "user";

export type AuthStore = {
  id: string | null;
  email?: string | null;
  isLoggedIn: boolean;
  firstName?: string | null;
  lastName?: string | null;
  claims: (UserClaim | undefined)[];
};

const getInitialState = (): AuthStore => {
  const defaultState: AuthStore = {
    id: null,
    isLoggedIn: false,
    claims: [],
  };

  try {
    const userRaw = globalThis.localStorage.getItem(USER_KEY);
    if (userRaw) {
      const userData = JSON.parse(userRaw) as AuthStore;
      return { ...userData, isLoggedIn: false };
    }
  } catch {
    // Invalid localStorage data, use defaults
  }

  return defaultState;
};

const authStore = new Store<AuthStore>(getInitialState());

export function saveAuthState(state: AuthStore) {
  localStorage.setItem(USER_KEY, JSON.stringify(state));
  authStore.update((s) => {
    s.id = state.id;
    s.email = state.email;
    s.isLoggedIn = true;
    s.firstName = state.firstName;
    s.lastName = state.lastName;
    s.claims = state.claims;
  });
}

export function getPersistedAuthState(): AuthStore | null {
  const userRaw = localStorage.getItem(USER_KEY);
  return userRaw ? (JSON.parse(userRaw) as AuthStore) : null;
}

export function clearAuthState() {
  localStorage.removeItem(USER_KEY);
  authStore.update((s) => {
    s.isLoggedIn = false;
    s.id = null;
    s.email = null;
    s.firstName = null;
    s.lastName = null;
    s.claims = [];
  });
}

export function logout() {
  localStorage.removeItem(USER_KEY);
  window.location.href = "Account/Logout";
}

export default authStore;
